import { useIsBrowsingPage } from '@/hooks/useIsBrowsingPage';
import { useNewSimilarItemsCTAExperiment } from '@/utils/amplitude/experiments/hooks/useNewSimilarItemsCTA';
import ImageRow from '@/components/ItemCard/ImageRow';
import ItemCardSaveIcon from '@/components/GridItemCard/Card/components/ItemCardSaveIcon/ItemCardSaveIcon';

export type CardImageProps = {
    applyDimensionToUrl?: boolean;
    canShowEasyShipping: boolean;
    className?: string;
    dimension?: number;
    enterLinkHoverState: () => void;
    imageQuality?: number;
    isLabeledFavoriteButton?: boolean;
    isMobile: boolean;
    itemId: number;
    lazyLoadImage: boolean;
    leaveLinkHoverState: () => void;
    onNavigate?: () => void;
    sharpenImage?: boolean;
};

const CardImage = ({
    applyDimensionToUrl,
    canShowEasyShipping,
    className,
    dimension,
    enterLinkHoverState,
    imageQuality,
    isLabeledFavoriteButton,
    isMobile,
    itemId,
    lazyLoadImage,
    leaveLinkHoverState,
    onNavigate,
    sharpenImage,
}: CardImageProps) => {
    const isBrowsingPage = useIsBrowsingPage();

    // Experiment SEAR-769: New similar items CTA experiment
    const { hasNewSimilarItemsIconCTA, hasNewSimilarItemsTextCTA } = useNewSimilarItemsCTAExperiment();
    const isLabeled = hasNewSimilarItemsIconCTA
        ? false
        : !isMobile && (hasNewSimilarItemsTextCTA || isLabeledFavoriteButton || isBrowsingPage);

    return (
        <section className="relative">
            <span className="absolute right-2 top-2 z-[10]">
                <ItemCardSaveIcon
                    canShowEasyShipping={canShowEasyShipping}
                    itemId={itemId}
                    labeled={isLabeled}
                />
            </span>
            <ImageRow
                applyDimensionToUrl={applyDimensionToUrl}
                className={`grid-area-itemimage ${className}`}
                dimension={dimension}
                imageQuality={imageQuality}
                itemId={itemId}
                lazyLoadImage={lazyLoadImage}
                onMouseEnter={enterLinkHoverState}
                onMouseLeave={leaveLinkHoverState}
                onNavigate={onNavigate}
                sharpenImage={sharpenImage}
                showImageWithHover={!isMobile}
            />
        </section>
    );
};

export default CardImage;
